export default __webpack_public_path__ + "static/media/Banner_Catsul_menor_500x400.71c242e7.jpg";